import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/badge-success.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0b4b3f88")

_pushScopeId("data-v-0b4b3f88")
const _hoisted_1 = {
  class: "flex flex-col items-center w-full",
  "data-testid": "pickup-request-success-modal"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-20 h-20 flex items-center justify-center mb-4" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-full h-full",
    alt: "success",
    "data-testid": "pickup-request-success-modal-icon"
  })
], -1)
const _hoisted_3 = {
  class: "text-lg font-semibold text-gray-lp-300 text-center mb-2",
  "data-testid": "pickup-request-success-modal-title"
}
const _hoisted_4 = { class: "text-sm text-gray-lp-800 text-center mb-4 leading-relaxed" }
const _hoisted_5 = {
  class: "font-semibold text-gray-lp-800",
  "data-testid": "pickup-request-success-modal-order-id"
}
const _hoisted_6 = { class: "w-full grid grid-cols-3 border border-gray-lp-200 rounded-lg p-4 mb-2 text-sm text-gray-lp-800" }
const _hoisted_7 = {
  class: "col-span-1 text-center",
  "data-testid": "pickup-request-success-modal-summary-total"
}
const _hoisted_8 = { class: "text-gray-lp-300" }
const _hoisted_9 = { class: "text-black-lp-100 text-black-lp-100 font-semibold" }
const _hoisted_10 = {
  class: "col-span-1 border-l border-r border-gray-lp-1500 text-center",
  "data-testid": "pickup-request-success-modal-summary-date"
}
const _hoisted_11 = { class: "text-gray-lp-300" }
const _hoisted_12 = { class: "text-black-lp-100 font-semibold" }
const _hoisted_13 = {
  class: "col-span-1 text-center",
  "data-testid": "pickup-request-success-modal-summary-time"
}
const _hoisted_14 = { class: "text-gray-lp-300" }
const _hoisted_15 = { class: "text-black-lp-100 font-semibold" }
const _hoisted_16 = { class: "flex flex-row justify-center gap-x-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        width: "w-600px",
        onClose: _ctx.onClose,
        showBorderTitle: false,
        titlePadding: 'p-0',
        contentPadding: 'px-8 pt-4 pb-0',
        footerPadding: 'px-8 py-0 pb-2',
        marginHeader: 'mb-0',
        marginFooter: 'mt-0',
        isShadows: false,
        closeButtonTestId: 'pickup-request-success-modal-button-close',
        footerBgColor: 'bg-white',
        borderTop: 'border-t-0'
      }, {
        content: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("pickup.requestSuccess.title")), 1),
            _createVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t("pickup.requestSuccess.description")) + " ", 1),
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.orderId), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pickup.requestSuccess.description2")), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("pickup.requestSuccess.summary.totalLabel")), 1),
                _createVNode("p", _hoisted_9, _toDisplayString(_ctx.formattedTotalRequest), 1)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("pickup.requestSuccess.summary.dateLabel")), 1),
                _createVNode("p", _hoisted_12, _toDisplayString(_ctx.formattedPickupDate), 1)
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("pickup.requestSuccess.summary.timeLabel")), 1),
                _createVNode("p", _hoisted_15, _toDisplayString(_ctx.formattedPickupTime), 1)
              ])
            ])
          ])
        ]),
        footer: _withId(() => [
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_LpButton, {
              "data-testid": "pickup-request-success-modal-button-close",
              "is-width-full": "",
              title: _ctx.$t('pickup.requestSuccess.button.close'),
              outline: "",
              color: "gray-lp-1600",
              "text-color": "black-lp-100",
              class: "py-3",
              onClick: _ctx.onClose
            }, null, 8, ["title", "onClick"]),
            _createVNode(_component_LpButton, {
              "data-testid": "pickup-request-success-modal-button-view-detail",
              "is-width-full": "",
              title: 
            _ctx.isDhlWhitelist
              ? _ctx.$t('pickup.requestSuccess.button.viewDetailAWB')
              : _ctx.$t('pickup.requestSuccess.button.viewDetail')
          ,
              outline: "",
              color: "red-lp-300",
              "text-color": "red-lp-300",
              class: "py-3",
              onClick: _ctx.goToDetail
            }, null, 8, ["title", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
})